import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class NavigationStore implements OnDestroy {
  protected currentComponent$: BehaviorSubject<string>;

  constructor() {
    this.createDefaultValues();
  }

  createDefaultValues(): void {
    this.currentComponent$ = <BehaviorSubject<string>>new BehaviorSubject('');
  }

  purge() {
    this.createDefaultValues();
  }

  ngOnDestroy() {}

  setCurrentComponent(str: string) {
    this.currentComponent$.next(str);
  }
  getCurrentComponentValue(): string {
    return this.currentComponent$.value;
  }
  getCurrentComponent(): Observable<string> {
    return this.currentComponent$.asObservable();
  }
}
